import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="materials" name="Materials"/>
        </div>
      )

}

export default AssetsList;